import * as React from "react";
import * as ReactDOM from "react-dom";
import {connect} from "react-redux";

interface Props
{
    visible: boolean;
    title: string;
    children: React.ReactNode;
}

import './OutputTooltip.scss';

export default class OutputTooltip extends React.Component<Props, null>
{
    constructor(public props: Props)
    {
        super(props);
    }


    /**
     * render the component
     * @returns {JSX.Element}
     */
    render() : JSX.Element
    {
        const {children, title, visible} = this.props;

        return <div styleName={visible ? 'visible' : 'hidden'}>

            <h4 styleName={'title'}>{title}</h4>

            <p styleName={'text'}>{children}</p>

        </div>
    }
}


// WEBPACK FOOTER //
// ./src/ts/app/screens/game/game-ui/outputs/output-tooltip/OutputTooltip.tsx